<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="6">
                <password-change-form v-on:submit="onSubmit" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import accountApi from '@/api/accountApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'password-change-form': () => import('@/views/PasswordChangeForm.vue')
    },
    methods: {
        async onSubmit(params) {
            await accountApi.changePassword(params);
            snackbar.show('Password changed successfully.', 'success');
        }
    }
};
</script>
